// @flow

import React, { Component } from 'react';

import { validate } from 'redux-form-jsonschema-reactstrap';

import { RadioButtonGroupInput, required } from 'react-admin';
// WORKS WITH AN OLDER VERSION ON MATERIAL-UI


export class InputField extends Component<*, *, *> {
  static defaultProps = {
    required: false,
    schemaVis: {}
  };

  props: {
    schemaVis: {
      schema: any
    },
    component: any,
    type: string,
    name: string,
    required: boolean,
    classes: { [string]: any }
  };

  validate = (value, allValues, props, name) => {
    const { schemaVis: { schema }, required } = this.props;
    return validate(schema, required)(value, allValues, props, name);
  }

  render() {
    const {
      schemaVis,
      name,
      component,
      requiredBool,
      ...rest
    } = this.props;
    const min = schemaVis.schema.minimum || 0;
    const max = schemaVis.schema.maximum || 10;
    const step = schemaVis.schema.step || 1;
    //const value = schemaVis.schema.default || undefined
    var items = []
    for (var i = min; i <= max; i = i + step) {
        items.push({id: ""+i, name:String(i), key:String(i) })
    }
    return (
      <RadioButtonGroupInput
        label={schemaVis.schema.title || name}
        source={name}
        choices={items}
        required={requiredBool}
        validate={required('required')}
        {...rest}
        />
    );
  }
}

function select(_options: CreateInputOptionsType) {
  const { styles, ...options } = _options;
  class CreatedInputField extends Component {
    render() {
      return <InputField {...this.props} {...options} />;
    }
  }

  return CreatedInputField;
}

export default select({})
